// The one media placeholder glyph (DES1): a framed landscape. The viewer renders it, and the
// Office export (EXP) and the App Kit's .pc-img-glyph (APP) map this geometry instead of
// copying it. Plain data, no React: a 24 × 24 outline, stroked in the current colour, unfilled.
export const MEDIA_PLACEHOLDER_GLYPH = Object.freeze({
  viewBox: '0 0 24 24',
  rect: Object.freeze({ x: 3.5, y: 5, width: 17, height: 14, rx: 2 }),
  circle: Object.freeze({ cx: 9, cy: 10, r: 1.6 }),
  path: 'm5 17 4.5-4.5 3 3 2.5-2.5L19 17',
  stroke: Object.freeze({ width: 1.5, linecap: 'round', linejoin: 'round' }),
  fill: 'none',
} as const);

export type MediaPlaceholderGlyph = typeof MEDIA_PLACEHOLDER_GLYPH;
